import { ErrorDetails } from 'store/error/types'

export const defaultError: ErrorDetails = {
  title: 'Houve um erro por aqui',
  subTitle:
    'No momento, essa funcionalidade está indisponível. Por favor, tente novamente em alguns minutos.',
  disabledButton: false,
}
